import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DashBoardMenu from 'src/components/app/DashBoardMenu';
import { reports } from 'src/routes/routes';
import LimitedWidthPage from 'src/components/PageWrappers/LimitedWidthPage';
import useRoutes from 'src/routes/useRoutes';
const ArgosEvents = React.lazy(() => import('./ArgosEventsReport'));
const MainReport = React.lazy(() => import('./ConfirmWorkHoursReport/MainReport'));
const MainReportV2 = React.lazy(() => import('./ConfirmWorkHoursReport/MainReportV2'));
const DetailedSummaryReport = React.lazy(() => import('./DetailedSummaryReport'));
const MachineTimesContainer = React.lazy(() => import('./MachineTimes'));
const ProjectsByJobs = React.lazy(() => import('./ProjectsByJobs'));
const RewardsReport = React.lazy(() => import('./RewardsReport'));
const TableHistory = React.lazy(() => import('./TableHistory'));
const UnscheduledWork = React.lazy(() => import('./UnscheduledWork'));
const WorkAndAbsence = React.lazy(() => import('./WorkAndAbsence'));
const WorkHoursExport = React.lazy(() => import('./WorkHoursExport'));
const WorksInDepartmentsContainer = React.lazy(() => import('./WorkInDepartments'));
const WorksInOtherDepartmentsContainer = React.lazy(() => import('./WorkTimesInOtherDepartments'));
const WorkTimeByDays = React.lazy(() => import('./WorkTimesByDays'));
const WorkTimes = React.lazy(() => import('./WorkTimes'));
const WorktimesInPeriodByJobsContainer = React.lazy(() => import('./WorkTimesInPeriodByJobs'));
const WorkTimeSummary = React.lazy(() => import('./WorkTimeSummary'));
const LawReport = React.lazy(() => import('./LawReport'));
const FlexibleWorkTimeMonitoring = React.lazy(() => import('./FlexibleWorkTimeMonitoring'));
function ReportMenu() {
    const { getAllowedRoutes } = useRoutes();
    const renderMenu = () => (React.createElement(LimitedWidthPage, null,
        React.createElement(DashBoardMenu, { routes: getAllowedRoutes(reports.subPages), sortAlphabetically: true })));
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "/reports/employeesReport", component: WorksInDepartmentsContainer }),
        React.createElement(Route, { path: "/reports/tableHistoryReport", component: TableHistory }),
        React.createElement(Route, { path: "/reports/worksInOtherDepartmentsReport", component: WorksInOtherDepartmentsContainer }),
        React.createElement(Route, { path: "/reports/worksReport", component: WorktimesInPeriodByJobsContainer }),
        React.createElement(Route, { path: "/reports/workTimesReport", component: WorkTimes }),
        React.createElement(Route, { path: "/reports/workAndAbsencesReport", component: WorkAndAbsence }),
        React.createElement(Route, { path: "/reports/machineTimesReport", component: MachineTimesContainer }),
        React.createElement(Route, { path: "/reports/exportToAxaptaReport", component: WorkHoursExport }),
        React.createElement(Route, { path: "/reports/mainReportOld", component: MainReport }),
        React.createElement(Route, { path: "/reports/mainReport", component: MainReportV2 }),
        React.createElement(Route, { path: "/reports/detailedSummaryReport", component: DetailedSummaryReport }),
        React.createElement(Route, { path: "/reports/summaryReport", component: WorkTimeSummary }),
        React.createElement(Route, { path: "/reports/worksInProjectsReport", component: ProjectsByJobs }),
        React.createElement(Route, { path: "/reports/argosEventsLogReport", component: ArgosEvents }),
        React.createElement(Route, { path: "/reports/workByDaysReport", component: WorkTimeByDays }),
        React.createElement(Route, { path: "/reports/unscheduledWork", component: UnscheduledWork }),
        React.createElement(Route, { path: "/reports/rewardReport", component: RewardsReport }),
        React.createElement(Route, { path: "/reports/lawReport", component: LawReport }),
        React.createElement(Route, { path: "/reports/flexibleWorkTimeMonitoringReport", component: FlexibleWorkTimeMonitoring }),
        React.createElement(Route, { path: "/reports", component: renderMenu })));
}
export default ReportMenu;
